<template>
<!-- product list item start -->
<div>
  <div class="product-list-item mb-20">
      <div class="product-thumb">
          <a><img  :src="getPicture" :alt="product.Title"></a>
          <div class="box-label">
            <template v-if="this.hasPackageData">
            <div class="product-label new"><span>PAKKET</span></div>
            </template>
          </div>
          <div class="product-action-link"></div>
      </div>
      <div class="product-list-content col-lg-18 col-md-18 col-sm-18 col-xs-12">
          <h3>{{product.Title}}</h3>
          <h5 v-if="!isHideTime">{{this.totalDurationInfoMsg}} {{product.IntDuration}} min.</h5>
          <div class="pricebox" v-if="!getPrice">
              <span class="regular-price">&euro;{{product.Price}} incl. BTW</span>
          </div>
  
          <template v-if="this.hasPackageData">
              <br>
              <h5 style="font-weight: bold;">Dit pakket bevat volgende behandelingen</h5>
              <ul>
              <template v-for="serv in product.Childs">
                  <li>{{serv.Title}}</li>
              </template>
              </ul>
              
           </template>
          <br>
          <div class="product-btn">
              <product-button :product="product" ></product-button>
          </div>
      </div>

       

  </div>

   <div class="row">
      <div class="col-1"></div>
      <router-link :to="'/'" class="product-link">
      <div class="row product-btn" >
              <a><i class="ion-arrow-left-c" ></i>Terug</a>
            </div>
      </router-link>
   </div>
   <div class="row">&nbsp;</div>
</div>  
 

</template>

<script>
  import ProductButton from './ProductButton'
  import Vue from 'vue';

  export default {
    props: ['product'],
    components: {
      'product-button': ProductButton
    },
    data () {
      return {
        isHideTime : false
      }
    },
    mounted () {
       this.isHideTime = Vue.$storeSettings.IsHideTime;
    },
    methods: {
       navBack () {
         this.$router.go (-1);
       },
    },
    computed: {
       hasPackageData () {
         if (this.product.Childs == null) {return false;}
         if (this.product.Childs.length > 0) {return true;}
         return false;
       },
       totalDurationInfoMsg () {
          if (this.hasPackageData) return "Totale behandeltijd ongeveer";
          return "Behandeling duurt ongeveer";
       },
       getPicture () {
           return Vue.$currCatPicUrl;
       },
      getPrice () {
           if (this.product.Price == "0") {return true;}
           return Vue.$storeSettings.IsHidePrices;
       }
     }
  }
</script>
<style>
  .product-thumb {
      margin : 10px;
  }
  .product-details {
    border-bottom: 2px solid #F5F5F5;
    padding: 30px 0;
  }
  .product-details__image {
  }
  .product-details__description {
    padding-top: 30px;
  }
  .product-details__description small {
    color: #fff;
  }
  .product-details__description h3 {
    margin: 5px 0 30px 0;
  }
  .product-details__price-cart {
    display: flex;
    padding-top: 30px;
  }
  .product-details__price-cart p {
    flex-grow: 2;
    font-size: 20px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/products/ProductDetails.vue